module.exports = __webpack_public_path__ + "img/ico-pago-pendiente-w.0748e28e.svg";